import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { RoleName } from "consts/auth";
import { withAuthorization } from "ui/layouts/Auth";
import SendNotification from "./SendNotification";
import CheckStatus from "./CheckStatus";
import FakeRedirect from "./FakeRedirect";
import Refund from "./Refund";
import PartialRefund from "./PartialRefund";
import SettlePingOrder from "./SettlePingOrder";
import ClosePingOrder from "./ClosePingOrder";

const TransactionActions = () => (
    <Stack
        direction='row'
        px={2}
        pb={2}
        spacing={1}
        divider={(
            <Divider />
        )}
    >
        <SendNotification />
        <CheckStatus />
        <FakeRedirect />
        <Refund />
        <PartialRefund />
        <SettlePingOrder />
        <ClosePingOrder />
    </Stack>
);

export default withAuthorization(TransactionActions, {
    roles: [
        RoleName.Admin
    ],
    fallback: null
});
